import { render, staticRenderFns } from "./CreateBeneSendMoney.vue?vue&type=template&id=ca0cd09e&scoped=true&"
import script from "./CreateBeneSendMoney.vue?vue&type=script&lang=js&"
export * from "./CreateBeneSendMoney.vue?vue&type=script&lang=js&"
import style0 from "./CreateBeneSendMoney.vue?vue&type=style&index=0&id=ca0cd09e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0cd09e",
  null
  
)

export default component.exports